import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareOwnExtraServiceBook', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareOwnExtraServiceBook/${basketKey}`, request)
}

export {post, put}
